// extracted by mini-css-extract-plugin
module.exports = {"item":"Ride_item__1o9iC","content":"Ride_content__36ESy","count":"Ride_count__2_n8d","button":"Ride_button__5oZdb"};